import { Service, Product, Shipping } from '../../../../requests/caipirinha-api/interfaces/order.interface';

const getSumOfProductsValues = (products?: Product[]) => {
  if (products) {
    return products.reduce(
      (prev, product) => prev + product.value * product.quantity, 0,
    );
  }
  return 0;
};

const getSumOfAllServicesValue = (services?: Service[], products?: Product[]) => {
  let servicesTotal = 0;
  let productServicesTotal = 0;

  if (services) {
    servicesTotal += services.reduce(
      (prev, service) => prev + service.value * service.quantity, 0,
    );
  }

  if (products) {
    const productsServices = products.flatMap(item => item.services || [])
      .filter(item => !!item);

    if (productsServices.length > 0) {
      productServicesTotal += productsServices.reduce(
        (prev, service) => prev + service.value * service.quantity,
        0,
      );
    }
  }

  return servicesTotal + productServicesTotal;
};

const getNumberOfServices = (services?: Service[], products?: Product[]) => {
  let servicesAmount = 0;
  let productServicesAmount = 0;

  if (services) {
    servicesAmount += services.reduce(
      (prev, service) => prev + service.quantity, 0,
    );
  }

  if (products) {
    const productsServices = products.flatMap(item => item.services || [])
      .filter(item => !!item);

    if (productsServices.length > 0) {
      productServicesAmount += productsServices.reduce(
        (prev, service) => prev + service.quantity,
        0,
      );
    }
  }

  return servicesAmount + productServicesAmount;
};

const getShippingValue = (shipping?: Shipping) => {
  if (shipping) {
    return shipping.value;
  }
  return 0;
};

const getAssemblyTotal = (products?: Product[]) => {
  if (products) {
    return products.flatMap(product => {
      if (product.assembly) {
        return product.assembly.value * product.quantity;
      }
      return 0;
    })
      .reduce((prev, curr) => prev + curr, 0);
  }

  return 0;
};

const getOrderTotal = (services?: Service[], products?: Product[], shipping?: Shipping) => {
  return (
    getSumOfAllServicesValue(services, products) +
    getSumOfProductsValues(products) +
    getShippingValue(shipping)
  );
};

export default {
  getSumOfProductsValues,
  getSumOfAllServicesValue,
  getNumberOfServices,
  getShippingValue,
  getAssemblyTotal,
  getOrderTotal,
};
